/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVoucherInfoByDateReportApiRequest } from '../../models/get-voucher-info-by-date-report-api-request';
import { GetVoucherResponseInfoArrayResultApiResult } from '../../models/get-voucher-response-info-array-result-api-result';

export interface ApiHotelGetVoucherByDatePost$Params {
      body: GetVoucherInfoByDateReportApiRequest
}

export function apiHotelGetVoucherByDatePost(http: HttpClient, rootUrl: string, params: ApiHotelGetVoucherByDatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVoucherResponseInfoArrayResultApiResult>> {
  const rb = new RequestBuilder(rootUrl, apiHotelGetVoucherByDatePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetVoucherResponseInfoArrayResultApiResult>;
    })
  );
}

apiHotelGetVoucherByDatePost.PATH = '/api/hotel/GetVoucherByDate';
